export type Scale = "us40" | "us43" | "india10";
export const SCALES: Record<Scale, { label: string; grades: Record<string, number>; max: number }> = {
  us40: { label: "US 4.0 (A+ = 4.0)", max: 4, grades: { "A+": 4.0, A: 4.0, "A-": 3.7, "B+": 3.3, B: 3.0, "B-": 2.7, "C+": 2.3, C: 2.0, "C-": 1.7, "D+": 1.3, D: 1.0, "D-": 0.7, F: 0 } },
  us43: { label: "US 4.3 (A+ = 4.3)", max: 4.3, grades: { "A+": 4.3, A: 4.0, "A-": 3.7, "B+": 3.3, B: 3.0, "B-": 2.7, "C+": 2.3, C: 2.0, "C-": 1.7, "D+": 1.3, D: 1.0, "D-": 0.7, F: 0 } },
  india10: { label: "India 10-point CGPA", max: 10, grades: { O: 10, "A+": 9, A: 8, "B+": 7, B: 6, C: 5, P: 4, F: 0 } },
};
export type Weight = "regular" | "honors" | "ap";
export const WEIGHT_BONUS: Record<Weight, number> = { regular: 0, honors: 0.5, ap: 1 };

export interface CourseInput { credits: string; grade: string; weight?: Weight }
export interface GpaResult {
  gpa: number | null; totalCredits: number; qualityPoints: number; errors: Record<number, string>;
  percent?: number;
}

/** Credits must be a number above 0 (0.5 steps are fine). Weighted bonus is added only for passing grades (above F). */
export function calcGpa(courses: CourseInput[], scale: Scale, weighted: boolean, prior?: { gpa: number; credits: number } | null): GpaResult {
  const errors: Record<number, string> = {};
  let credits = 0, points = 0;
  courses.forEach((c, i) => {
    const raw = c.credits.trim().replace(",", ".");
    if (raw === "") { errors[i] = "Enter the credits."; return; }
    const cr = Number(raw);
    if (!Number.isFinite(cr)) { errors[i] = "Credits must be a number."; return; }
    if (cr <= 0) { errors[i] = "Credits must be more than 0."; return; }
    const gp = SCALES[scale].grades[c.grade];
    if (gp === undefined) { errors[i] = "Pick a grade."; return; }
    const bonus = weighted && scale !== "india10" && gp > 0 ? WEIGHT_BONUS[c.weight ?? "regular"] : 0;
    credits += cr; points += cr * (gp + bonus);
  });
  if (prior && prior.credits > 0 && Number.isFinite(prior.gpa)) { credits += prior.credits; points += prior.credits * prior.gpa; }
  const gpa = credits > 0 ? points / credits : null;
  return { gpa, totalCredits: credits, qualityPoints: points, errors, percent: scale === "india10" && gpa !== null ? gpa * 9.5 : undefined };
}
